import { Component, ComponentFactoryResolver, ComponentRef, OnInit, ViewContainerRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TemporalPageService } from '@shared/services/temporal-page.service';

@UntilDestroy()
@Component({
  selector: 'app-temporal-page',
  templateUrl: './temporal-page.component.html',
  styleUrls: ['./temporal-page.component.scss']
})
export class TemporalPageComponent implements OnInit {
  currentComponentRef: ComponentRef<any>;

  constructor(
    private temporalPageService: TemporalPageService,
    public viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) { }

  ngOnInit(): void {
    this.temporalPageService.temporalPageData$.pipe(untilDestroyed(this)).subscribe({
      next: (data) => {
        if (data.enabled && data.component) {
          this.createComponent(data.component);
        }
        if (!data.enabled) {
          this.destroyCurrentComponent()
        }
      }
    })
  }

  createComponent(dynamicComponent: any) {
    this.destroyCurrentComponent()
    const dynamicComponentFactory = this.componentFactoryResolver.resolveComponentFactory(dynamicComponent);
    this.currentComponentRef = this.viewContainerRef.createComponent(dynamicComponentFactory);
  }

  private destroyCurrentComponent() {
    if (this.currentComponentRef) {
      this.currentComponentRef.destroy();
    }
  }
}
